/**
 * Утилита для отложенной загрузки CSS файлов
 * Используется для некритических стилей, которые не должны блокировать первый рендер
 */

/**
 * Загружает CSS файл асинхронно без блокировки рендеринга
 * @param href - URL или путь к CSS файлу
 * @param id - Уникальный идентификатор для предотвращения дублирования
 */
export const loadCSS = (href: string, id?: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    // Проверяем, не загружен ли уже CSS с таким href или id
    const existingLink = id 
      ? document.querySelector(`link#${id}`)
      : document.querySelector(`link[href="${href}"]`);
    
    if (existingLink) {
      resolve();
      return;
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    if (id) {
      link.id = id;
    }
    
    link.onload = () => resolve();
    link.onerror = () => reject(new Error(`Failed to load CSS: ${href}`));
    
    document.head.appendChild(link);
  });
};

/**
 * Загружает CSS файл с использованием техники media="print" для асинхронной загрузки
 * Это более надежный способ для некритических стилей
 * @param href - URL или путь к CSS файлу
 * @param id - Уникальный идентификатор для предотвращения дублирования
 */
export const loadCSSAsync = (href: string, id?: string): void => {
  // Проверяем, не загружен ли уже CSS
  const existingLink = id 
    ? document.querySelector(`link#${id}`)
    : document.querySelector(`link[href="${href}"]`);
  
  if (existingLink) {
    return;
  }

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  link.media = 'print'; // Браузер загрузит файл, но не применит его сразу
  if (id) {
    link.id = id;
  }
  
  // После загрузки меняем media на 'all', чтобы стили применились
  link.onload = () => {
    link.media = 'all';
  };
  
  document.head.appendChild(link);
};

